import { ICellRendererParams } from 'ag-grid-community';
import { useEffect, useRef, useState } from 'react';
import { ROLES, Tabs } from 'common/constants';
import { TextRenderer } from 'components';
import { getSelectedTab } from 'pages/LandingPage/components/LandingPageHeader/slice';
import { getUserRole } from 'pages/LandingPage/slice';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import {
  addUpdatedInvoiceDescription,
  removeUpdatedInvoiceDescription
} from '../slice';
import { StyledInvoiceDesc } from '../styled';

export const InvoicesTextRenderer = ({
  value,
  data: { vendorNo, invoiceId }
}: ICellRendererParams): React.JSX.Element => {
  const dispatch = useAppDispatch();
  const originalDescription = useRef<string>(value);
  const [description, setDescription] = useState<string>(value);
  const userRole = useAppSelector(getUserRole);
  const selectedTab = useAppSelector(getSelectedTab);

  useEffect(() => {
    if (originalDescription.current !== description) {
      dispatch(
        addUpdatedInvoiceDescription({ vendorNo, invoiceId, description })
      );
    } else {
      dispatch(removeUpdatedInvoiceDescription({ vendorNo, invoiceId }));
    }
  }, [description, dispatch, invoiceId, vendorNo]);

  return (
    <StyledInvoiceDesc>
      <TextRenderer
        id={`${vendorNo as string}-${invoiceId as string}`}
        value={description}
        disabled={selectedTab !== Tabs.ToBePaid && userRole === ROLES.AP_CLERK}
        handleInputChange={setDescription}
      />
    </StyledInvoiceDesc>
  );
};
